import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import { CapitalizeSentencesPipe } from './pipes/capitalize-sentences.pipe';
import { TimezoneDatePipe } from './pipes/timezone-date.pipe';
import { FilterBySchedulePipe } from './pipes/filter-by-schedule.pipe';

@NgModule({
  declarations: [PhoneFormatPipe, CapitalizeSentencesPipe, TimezoneDatePipe, FilterBySchedulePipe],
  imports: [CommonModule],
  exports: [PhoneFormatPipe, CapitalizeSentencesPipe,TimezoneDatePipe, FilterBySchedulePipe]
})
export class SharedModule {}